import { openBlock as e, createElementBlock as l, createElementVNode as t } from "vue";
const o = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, n = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M20 40c11.046 0 20-8.954 20-20S31.046 0 20 0 0 8.954 0 20s8.954 20 20 20Z"
}, null, -1), s = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "M31.304 20.217H8.696c0 1.561 1.36 2.826 2.92 2.826h-.094a2.826 2.826 0 0 0 2.826 2.826 2.826 2.826 0 0 0 2.826 2.827h5.652a2.826 2.826 0 0 0 2.826-2.827 2.826 2.826 0 0 0 2.826-2.826h-.094c1.56 0 2.92-1.265 2.92-2.826Z"
}, null, -1), c = /* @__PURE__ */ t("path", {
  fill: "#338AF3",
  d: "M27.826 16.522a7.826 7.826 0 0 1-15.652 0"
}, null, -1), h = /* @__PURE__ */ t("path", {
  fill: "#FFDA44",
  d: "m25.978 16.522-2.443 1.149 1.3 2.365-2.652-.507-.336 2.68L20 20.237l-1.848 1.97-.336-2.68-2.652.508 1.3-2.366-2.442-1.148 2.443-1.15-1.3-2.365 2.651.508.337-2.68L20 12.805l1.847-1.97.336 2.68 2.653-.508-1.3 2.366 2.442 1.149Z"
}, null, -1), a = [
  n,
  s,
  c,
  h
];
function d(i, _) {
  return e(), l("svg", o, [...a]);
}
const f = { render: d };
export {
  f as default,
  d as render
};
